/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_SavedInputs */

const en_us2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal saved`)
};

const pt_br2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta salva`)
};

const es_419_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta guardada`)
};

const pt_pt2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo guardado`)
};

const fr_fr2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif enregistré`)
};

const de_de2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel gespeichert`)
};

const it_it2_exercise_personal_goal_saved = /** @type {(inputs: Exercise_Personal_Goal_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo salvato`)
};

/**
* | output |
* | --- |
* | "Goal saved" |
*
* @param {Exercise_Personal_Goal_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_saved = /** @type {((inputs?: Exercise_Personal_Goal_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_saved(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_saved(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_saved(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_saved(inputs)
	return en_us2_exercise_personal_goal_saved(inputs)
});
export { exercise_personal_goal_saved as "exercise-personal.goal_saved" }